'use client';

import { UiIcon } from '@/components/ui/UiIcon';
import { cn } from '@/lib/utils/tw-merge';
import { setTheme, useTheme } from './theme.store';

/** Light/dark switch (icon button, header). Sets an explicit .dark-mode/
 *  .light-mode class on <html> and persists the choice via the shared store. */
export function ThemeToggle({ className }: { className?: string }) {
    const isDark = useTheme() === 'dark';

    return (
        <button
            type="button"
            onClick={() => setTheme(isDark ? 'light' : 'dark')}
            aria-label={isDark ? 'Zu hellem Design wechseln' : 'Zu dunklem Design wechseln'}
            className={cn(
                'inline-flex size-9 shrink-0 items-center justify-center rounded-lg',
                'text-copy-2 [transition:var(--transition-button)]',
                'hover:-translate-y-0.5',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
                'cursor-pointer',
                className,
            )}
        >
            <UiIcon name={isDark ? 'sun' : 'moon'} size={16} />
        </button>
    );
}
